import type { Account } from "~mangomap-ui/templates/partner-templates/types";
import type { RawManagedAccount } from "./use-get-partner-managed-accounts";

type RawManagedAccountLike = RawManagedAccount;

export const toAccount = (raw: RawManagedAccountLike): Account => {
	return {
		id: raw.id,
		companyName: raw.companyName,
		slug: raw.slug,
		partnerId: raw.partnerId,
		createdAt: raw.createdAt,
		isPastDue: raw.isPastDue ?? false,
		mangomapSupportAccess: raw.mangomapSupportAccess ?? false,
		subscription: {
			type: raw.subscription.type,
			paidConfig: {
				plan: raw.subscription.paidConfig.plan,
				cycle: raw.subscription.paidConfig.cycle,
				addons: raw.subscription.paidConfig.addons,
			},
			trialExpiresAt: raw.subscription.trialExpiresAt ?? null,
			nextRenewalAt: raw.subscription._nextRenewalAt ?? null,
			currentPeriodAmount: raw.subscription._currentPeriodAmount ?? null,
			recurlySubscriptionId: raw.subscription.paidConfig.subscriptionID ?? null,
		},
		clientOwner: {
			...raw._clientOwner,
		},
		partnerActivationState: raw.partnerActivationState ?? undefined,
		isReverseHandoffInProgress: raw.isReverseHandoffInProgress ?? false,
		quotaUsage: {
			mapsUsed: raw._quotaUsage.mapsUsed,
			mapsLimit: raw._quotaUsage.mapsLimit,
			storageBytesUsed: raw._quotaUsage.storageBytesUsed,
			storageBytesLimit: raw._quotaUsage.storageBytesLimit,
			viewersUsed: raw._quotaUsage.viewersUsed,
			viewersLimit: raw._quotaUsage.viewersLimit ?? null,
			isViewersUnlimited: raw._quotaUsage.isViewersUnlimited,
			isAddOnsAllowed: raw._quotaUsage.isAddOnsAllowed,
			adminsUsed: raw._quotaUsage.adminsUsed,
			adminsLimit: raw._quotaUsage.adminsLimit,
			editorsUsed: raw._quotaUsage.editorsUsed,
			editorsLimit: raw._quotaUsage.editorsLimit,
		},
		managingPartner: null,
	};
};
